import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Form } from 'react-bootstrap';

import Header from '../components/header';
import InfoBar from '../components/InfoBar';
import { LabeledSelect } from '../components/LabeledSelect';
import api from '../util/api';
import { hasRoleWishlistEditor } from '../util/auth';

function ActionButtons({ onOk, onCancel }) {
    return (
        <div className="action-buttons">
            <div className="d-grid gap-2">
                <Button onClick={onOk} variant="secondary">Ok</Button>
                <Button onClick={onCancel} variant="outline-secondary">Abbrechen</Button>
            </div>
        </div>
    );
}

export function WishlistAdd() {
    const [shortName, setShortName] = useState('');
    const [location, setLocation] = useState('');
    const [tubeTypes, setTubeTypes] = useState([]);
    const [locations, setLocations] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        hasRoleWishlistEditor().then((hasRole) => {
            if (!hasRole) {
                setError('Sie haben nicht die notwendigen Rechte um diesen Vorgang durchzuführen.');
                return;
            }
            api.getTubeTypes()
                .then((types) => {
                    // sort alphabetically by short name
                    types.sort((a, b) => {
                        const aLetter = a.shortName.charAt(0);
                        const aNum = parseInt(a.shortName.substring(1), 10);
                        const bLetter = b.shortName.charAt(0);
                        const bNum = parseInt(b.shortName.substring(1), 10);
                        if (aLetter !== bLetter) return aLetter.localeCompare(bLetter);
                        return aNum - bNum;
                    });
                    setTubeTypes(types);
                    if (types.length > 0) setShortName(types[0].shortName);
                })
                .catch((err) => setError(`Fehler beim Laden der Prüfröhrchen-Typen: ${err}`));
            api.getLocations()
                .then((locs) => {
                    setLocations(locs);
                    if (locs.length > 0) setLocation(locs[0].name);
                })
                .catch((err) => setError(`Fehler beim Laden der Standorte: ${err}`));
        });
    }, []);

    function handleOk() {
        api.addToWishlist({ shortName, location, id: null })
            .then(() => navigate('/wishlist'))
            .catch((err) => setError(`Fehler beim Hinzufügen: ${err}`));
    }

    return (
        <div className="wishlist-commit-dialog">
            <Header />
            <InfoBar show={error !== ''} text={error} title="Fehler" color="#F00" />
            <Form>
                <Card className="form-group">
                    <Card.Header className="small">Bestellwunsch hinzufügen</Card.Header>
                    <Card.Body>
                        <LabeledSelect
                            id="wishlist-add-shortname"
                            label="Typ"
                            value={shortName}
                            onChange={setShortName}
                            options={tubeTypes.map((t) => ({ key: t.shortName, label: `${t.shortName} – ${t.fullName}` }))}
                        />
                        <LabeledSelect
                            id="wishlist-add-location"
                            label="Ort"
                            value={location}
                            onChange={setLocation}
                            options={locations.map((l) => ({ key: l.name, label: l.name }))}
                        />
                    </Card.Body>
                </Card>
            </Form>
            <ActionButtons onOk={handleOk} onCancel={() => navigate('/wishlist')} />
        </div>
    );
}
